import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './config/http'
import VueMaterial from 'vue-material'
import './config/element.js'

Vue.use(VueMaterial)
Vue.use(ElementUI, { size: 'mini' })
Vue.prototype.$bus = new Vue();
Vue.prototype.$http = http
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
